module.exports = __webpack_public_path__ + "static/ab_ausdollar_280220-77b5bc7fc3977285f1e312d0883d5892.jpg";